import React, { useState } from "react";
import DeleteOrderModal from "./deleteOrderModal"; // Import the modal

const OrderTable = ({
  currentOrders,
  indexOfFirstOrder,
  indexOfLastOrder,
  ordersLength,
  totalPages,
  currentPage,
  handlePageChange,
  handlePreviewModalOpen,
  handleEditModalOpen,
  handleDeleteModalOpen, 
}) => {
  const [openDropdown, setOpenDropdown] = useState(null); // Track which dropdown is open
  const [searchQuery, setSearchQuery] = useState(""); // Track the search input
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // Track delete modal visibility
  const [selectedOrder, setSelectedOrder] = useState(null); // Track which order is selected for deletion

  // Toggle dropdown for actions (preview, edit, delete)
  const toggleDropdown = (orderId) => {
    setOpenDropdown(openDropdown === orderId ? null : orderId);
  };



  const toggleModal = () => {
    setIsDeleteModalOpen(!isDeleteModalOpen); // Toggle modal visibility
  };

  // Filter orders based on search query
  const filteredOrders = currentOrders.filter((order) => {
    const isOrderIdMatch = order.order_id
      .toString()
      .includes(searchQuery.toLowerCase());
    const isNameMatch = order.name
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
    return isOrderIdMatch || isNameMatch;
  });

  return (
    <section className="flex-grow bg-gray-50 dark:bg-gray-900 p-3 sm:p-5 antialiased">
      <div className="mx-auto max-w-screen-xl px-4 lg:px-12">
        <div className="bg-white dark:bg-gray-800 relative shadow-md sm:rounded-lg overflow-hidden">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0 md:space-x-4 p-4">
            {/* Search Input */}
            <div className="w-full md:w-1/2">
              <form className="flex items-center">
                <label htmlFor="simple-search" className="sr-only">
                  Search
                </label>
                <div className="relative w-full">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <i className="fa fa-search text-gray-500 dark:text-gray-400"></i>
                  </div>
                  <input
                    type="text"
                    id="simple-search"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full pl-10 p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    placeholder="Search Orders by ID or Name"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery on input change
                  />
                </div>
              </form>
            </div>
          </div>

          {/* Orders Table */}
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th className="px-4 py-2 text-left text-sm font-medium text-gray-500">
                    Order ID
                  </th>
                  <th className="px-4 py-2 text-left text-sm font-medium text-gray-500">
                    Customer Name
                  </th>
                  <th className="px-4 py-2 text-left text-sm font-medium text-gray-500">
                    Status
                  </th>
                  <th className="px-4 py-2 text-left text-sm font-medium text-gray-500">
                    Total Amount
                  </th>
                  <th className="px-6 py-2 text-left text-sm font-medium text-gray-500">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredOrders.length > 0 ? (
                  filteredOrders.map((order) => (
                    <tr key={order.order_id} className="border-b dark:border-gray-700">
                      <td className="px-4 py-3">{order.order_id}</td>
                      <td className="px-4 py-3">{order.name}</td>
                      <td className="px-4 py-3">{order.status}</td>
                      <td className="px-4 py-3">${order.totalAmount.toFixed(2)}</td>
                      <td className="px-6 py-3 flex items-center justify-center">
                        <div className="relative inline-block text-left">
                          <div>
                            <button
                              type="button"
                              onClick={() => toggleDropdown(order.order_id)}
                              className="inline-flex justify-center p-2 text-sm font-medium text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md"
                              id="options-menu"
                              aria-haspopup="true"
                              aria-expanded="true"
                            >
                              <i className="fas fa-ellipsis-v"></i>
                            </button>
                          </div>
                          {openDropdown === order.order_id && (
                            <div className="absolute right-0 z-10 mt-2 w-48 bg-white dark:bg-gray-800 rounded-md shadow-lg">
                              <div className="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                                <button
                                  className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 w-full text-left"
                                  onClick={() => {
                                    handlePreviewModalOpen(order); // Open preview modal
                                    setOpenDropdown(null); // Close dropdown after action
                                  }}
                                >
                                  Preview
                                </button>
                                <button
                                  className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 w-full text-left"
                                  onClick={() => {
                                    handleEditModalOpen(order); // Open edit modal
                                    setOpenDropdown(null); // Close dropdown after action
                                  }}
                                >
                                  Edit
                                </button>
                                <button
                                  className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 w-full text-left"
                                  onClick={() => {
                                    handleDeleteModalOpen(order); // Open delete modal
                                    setOpenDropdown(null);
                                  }}
                                >
                                  Delete
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="px-6 py-3 text-center text-gray-500 dark:text-gray-400">
                      No orders found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Pagination and Entries Info */}
            <div className="p-4 flex justify-between items-center border-t dark:border-gray-700">
              <span className="text-sm text-gray-500 dark:text-gray-400">
                Showing {indexOfFirstOrder + 1} to{" "}
                {Math.min(indexOfLastOrder, ordersLength)} of {ordersLength}{" "}
                Entries
              </span>
              <div className="flex space-x-2">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                  (pageNumber) => (
                    <button
                      key={pageNumber}
                      className={`px-3 py-1 rounded-lg ${
                        currentPage === pageNumber
                          ? "bg-blue-600 text-white"
                          : "bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-400 hover:bg-gray-300 dark:hover:bg-gray-600"
                      }`}
                      onClick={() => handlePageChange(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  )
                )}
              </div>
            </div>
          </div>

       
        </div>
      </div>
    </section>
  );
};

export default OrderTable;
